const Bolt = ({ className }: { className?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none" className={className}>
      <path
        d="M6.77344 0.523438C7.21875 0.523438 7.54688 0.945312 7.42969 1.36719L6.16406 5.75H8.17969C8.625 5.75 9 6.125 9 6.57031C9 6.82812 8.88281 7.03906 8.69531 7.20312L2.625 12.3594C2.50781 12.4531 2.36719 12.5 2.20312 12.5C1.75781 12.5 1.42969 12.0781 1.54688 11.6562L2.8125 7.25H0.773438C0.351562 7.25 0 6.89844 0 6.47656C0 6.24219 0.09375 6.00781 0.257812 5.86719L6.35156 0.664062C6.46875 0.570312 6.60938 0.5 6.77344 0.5V0.523438ZM5.92969 2.49219L1.6875 6.125H3.5625C3.72656 6.125 3.89062 6.21875 4.00781 6.35938C4.10156 6.5 4.14844 6.6875 4.10156 6.85156L3.04688 10.5312L7.33594 6.875H5.4375C5.25 6.875 5.08594 6.80469 4.96875 6.66406C4.875 6.52344 4.82812 6.33594 4.875 6.17188L5.92969 2.49219Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Bolt
